"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReviewerDetails", {
  enumerable: true,
  get: function () {
    return _ReviewerDetails.ReviewerDetails;
  }
});
var _ReviewerDetails = require("./ReviewerDetails");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfUmV2aWV3ZXJEZXRhaWxzIiwicmVxdWlyZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Jldmlld3MvUmV2aWV3ZXJEZXRhaWxzL2luZGV4LnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBSZXZpZXdlckRldGFpbHMgfSBmcm9tIFwiLi9SZXZpZXdlckRldGFpbHNcIlxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBLElBQUFBLGdCQUFBLEdBQUFDLE9BQUEiLCJpZ25vcmVMaXN0IjpbXX0=